import { Box, BoxProps } from '@mui/material';
import { ReactNode } from 'react';

type SectionContentProps = {
  children: ReactNode;
} & BoxProps;

const SectionContent = ({ children, ...boxProps }: SectionContentProps) => {
  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' }}
      gap={2}
      {...boxProps}
    >
      {children}
    </Box>
  );
};

export default SectionContent;
